import React, { useEffect } from 'react';
import { Modal, Form, Input, Popconfirm, Button } from 'antd';
import { Dayjs } from 'dayjs';

interface BankHolidayModalProps {
  open: boolean;
  date: Dayjs | null;
  existing?: { name: string };
  onClose: () => void;
  onSave: (name: string) => void;
  onRemove: () => void;
  isSaving?: boolean;
  isRemoving?: boolean;
}

export const BankHolidayModal: React.FC<BankHolidayModalProps> = ({
  open,
  date,
  existing,
  onClose,
  onSave,
  onRemove,
  isSaving = false,
  isRemoving = false,
}) => {
  const [form] = Form.useForm<{ name: string }>();

  useEffect(() => {
    if (open) form.setFieldsValue({ name: existing?.name ?? '' });
  }, [open, existing, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    onSave(values.name.trim());
  };

  return (
    <Modal
      title={date ? `Bank Holiday — ${date.format('DD MMM YYYY')}` : 'Bank Holiday'}
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText={existing ? 'Update' : 'Mark as Bank Holiday'}
      confirmLoading={isSaving}
      footer={(_, { OkBtn, CancelBtn }) => (
        <div className="flex items-center justify-end gap-2">
          <CancelBtn />
          {existing && (
            <Popconfirm
              title="Remove this bank holiday?"
              onConfirm={onRemove}
              okText="Remove"
              okButtonProps={{ danger: true, loading: isRemoving }}
            >
              <Button danger loading={isRemoving}>Remove</Button>
            </Popconfirm>
          )}
          <OkBtn />
        </div>
      )}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Holiday Name"
          rules={[{ required: true, message: 'Please enter a holiday name' }]}
        >
          <Input placeholder="e.g. Christmas Day" autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BankHolidayModal;
